<template>
  <svg
    width="256"
    height="256"/>
</template>

<script>
import * as d3 from 'd3';

export default {
  name: 'NotaryProgressIndicator',
  props: {
    progressPercent: {
      type: Number,
      default: 0,
      required: true
    }
  },
  watch: {
    progressPercent(progress) {
      this.progress(progress);
    }
  },
  methods: {
    progress(progressPercent) {
      const fillPercent = Math.min(Math.max(Math.round(progressPercent), 0), 100);
      try {
        // this.#el - is the root element in <template>
        const vis = d3.select(this.$el);
        vis.select('svg').remove();
        const angle = (fillPercent * 2) / 100;

        const arc = d3.svg.arc()
          .innerRadius(50)
          .outerRadius(94)
          .startAngle(0)
          .endAngle(angle * Math.PI);

        vis.append('svg')
          .attr('width', 256)
          .attr('height', 256)
          .append('path')
          .attr('fill', '#40679c')
          .attr('fill-opacity', '0.5')
          .attr('d', arc)
          .attr('transform', 'translate(128, 128)');
      } catch (e) {
        console.log('d3 err:', e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
